import React, { useState, useCallback } from "react"
import { Link } from "react-router-dom"
import { Button, Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from "reactstrap"
import { Field as AvField, Form as AvForm } from "@availity/form"
import Dropzone from "react-dropzone"
// import ido from "idexo-sdk"

const ZksMintNFT = () => {
    const [selectedFiles, setSelectedFiles] = useState([])
    const [name, setName] = useState("")
    const [description, setDescription] = useState("")
    const [attributes, setAttributes] = useState([{ name: "", value: "" }])
    const [mintToAddress, setMintToAddress] = useState("")
    const [network, setNetwork] = useState("zksync")

    const formatBytes = useCallback((bytes, decimals = 2) => {
        if (bytes === 0) return "0 Bytes"
        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

        const i = Math.floor(Math.log(bytes) / Math.log(k))
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
    }, [])

    const handleAcceptedFiles = async (files) => {
        const toBase64 = (file) =>
            new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () =>
                    resolve(
                        Object.assign(file, {
                            preview: URL.createObjectURL(file),
                            formattedSize: formatBytes(file.size),
                            base64: reader.result.split(",")[1]
                        })
                    )
                reader.onerror = (error) => reject(error)
            })

        const base64Files = await Promise.all(files.map((file) => toBase64(file)))
        setSelectedFiles(base64Files)
    }

    const handleSubmit = async (event) => {
        event.preventDefault()
        const attributesObj = {}
        attributes.forEach((attribute) => {
            attributesObj[attribute.name] = attribute.value
        })

        if (selectedFiles.length === 0 || selectedFiles[0].base64 === undefined) {
            alert("Please upload NFT image")
            return
        }

        if (network === "zksync") {
            // Assuming ido.React.mintBEP721 is available in the scope or imported
            // const result = await ido.React.mintBEP721(
            //     '0x6bd3a139ebad80fc95deeda14688b061971a415f',
            //     mintToAddress,
            //     selectedFiles[0].base64,
            //     selectedFiles[0].type,
            //     name,
            //     description,
            //     attributesObj,
            //     // Assuming jwt and localStorage are available in the scope
            // );
            // const { data, status, statusText } = result;
            // let status === 200;
            // if (status === 200) {
            //     alert(`NFT successfully minted. Address is: ${data}`);
            // } else {
            //     alert(`Minting NFT failed. StatusCode: ${status}. Reason: ${statusText}`);
            // }
        }
    }

    return (
        <React.Fragment>
            <div className="content">
                <Row>
                    <Col xs="12">
                        <Card>
                            <CardBody>
                                <CardTitle className="h4">Mint NFT</CardTitle>
                                <p className="card-title-desc">Provide a name, description, and media file for your NFT</p>

                                <AvForm initialValues={{ nftname: "" }} onSubmit={handleSubmit}>
                                    <Row>
                                        <Col sm="6">
                                            <FormGroup className="mb-3">
                                                <AvField
                                                    name="nftname"
                                                    label="Name"
                                                    placeholder="Enter NFT Name"
                                                    type="text"
                                                    onChange={(e) => setName(e.target.value)}
                                                    required
                                                />
                                            </FormGroup>
                                            <FormGroup className="mb-3">
                                                <AvField
                                                    name="metadescription"
                                                    label="Description"
                                                    placeholder="Description"
                                                    type="textarea"
                                                    onChange={(e) => setDescription(e.target.value)}
                                                    rows="5"
                                                    required
                                                />
                                            </FormGroup>
                                            <FormGroup className="mb-3">
                                                <Row>
                                                    <Col sm="6">
                                                        <Label>Attribute Name</Label>
                                                        {attributes.map((attribute, index) => (
                                                            <Input
                                                                key={`attribute_name_${index}`}
                                                                type="text"
                                                                className="form-control mb-1"
                                                                onChange={(e) => {
                                                                    const newAttributes = [...attributes]
                                                                    newAttributes[index].name = e.target.value
                                                                    setAttributes(newAttributes)
                                                                }}
                                                                value={attribute.name}
                                                            />
                                                        ))}
                                                    </Col>
                                                    <Col sm="6">
                                                        <Label>Value</Label>
                                                        {attributes.map((attribute, index) => (
                                                            <Input
                                                                key={`attribute_value_${index}`}
                                                                type="text"
                                                                className="form-control mb-1"
                                                                onChange={(e) => {
                                                                    const newAttributes = [...attributes]
                                                                    newAttributes[index].value = e.target.value
                                                                    setAttributes(newAttributes)
                                                                }}
                                                                value={attribute.value}
                                                            />
                                                        ))}
                                                    </Col>
                                                </Row>
                                                <Button color="primary" onClick={() => setAttributes([...attributes, { name: "", value: "" }])}>
                                                    Add Attribute
                                                </Button>
                                            </FormGroup>
                                        </Col>

                                        <Col sm="6">
                                            <FormGroup className="mb-3">
                                                <Label>Network</Label>
                                                <Input type="select" name="network" value={network} onChange={(e) => setNetwork(e.target.value)}>
                                                    <option>Select</option>
                                                    <option value="zksync">zkSync Era Mainnet</option>
                                                    <option value="zksnctestnet">zkSync Testnet</option>
                                                </Input>
                                            </FormGroup>
                                            <FormGroup className="mb-3">
                                                <AvField
                                                    name="mintoaddress"
                                                    label="Mint To Address"
                                                    placeholder="Enter Mint To Address"
                                                    type="text"
                                                    onChange={(e) => setMintToAddress(e.target.value)}
                                                    required
                                                />
                                            </FormGroup>
                                            <FormGroup className="mb-3">
                                                <Label for="dropzone">Upload File</Label>
                                                <div className="dropzone">
                                                    <Dropzone onDrop={(acceptedFiles) => handleAcceptedFiles(acceptedFiles)}>
                                                        {({ getRootProps, getInputProps }) => (
                                                            <div {...getRootProps({ className: "dropzone" })}>
                                                                <input {...getInputProps()} />
                                                                <p>Drop files here or click to upload.</p>
                                                            </div>
                                                        )}
                                                    </Dropzone>
                                                </div>
                                                <div className="dropzone-previews mt-3">
                                                    {selectedFiles.map((file, index) => (
                                                        <div key={index} className="dz-preview dz-file-preview">
                                                            <div className="dz-image">
                                                                <img src={file.preview} alt={file.name} />
                                                            </div>
                                                            <div className="dz-details">
                                                                <div className="dz-size">
                                                                    <span>{file.formattedSize}</span>
                                                                </div>
                                                                <div className="dz-filename">
                                                                    <span>{file.name}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <div className="d-flex flex-wrap gap-2">
                                        <Button type="submit" color="primary">
                                            Mint
                                        </Button>
                                        <Button type="reset" color="secondary">
                                            Cancel
                                        </Button>
                                    </div>
                                </AvForm>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}

export default ZksMintNFT
